import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/apple_logo.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/google_play_logo.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/ifood-logo.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/popeyes-stars.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/icons/rappi-logo.svg");
;
import(/* webpackMode: "eager" */ "/workspace/public/images/img-phone-popeyes-desktop.webp");
;
import(/* webpackMode: "eager" */ "/workspace/public/images/img-phone-popeyes-mobile.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/carousel.tsx");
